'use strict';

var _ = require('lodash');
var AdvancedHepGridController = function AdvancedHepGridController($scope, advancedGridService, advancedHepGridValidationService, advancedHepGridActionsService, dataRetrieverService, cellLinkRendererFactory, dataRetrieverConstantsService, configurationParametersAdvancedDataProviderService, featureToggleService, hepService, $rootScope) {
  var QUERYING_MORE_DOMAINS_TYPES = ['FP_MarketConfig'];
  var PRE_POPULATE_CURTAIN_RULE_DROPDOWNS_TYPES = ['FlightCurtainRuleId'];
  var PRE_POPULATE_FARE_BRAND_DROPDOWN_TYPES = ['DA_FareBrandNormalization', 'DA_FareBrandAssignment'];
  var PRE_POPULATE_FOR_VALIDATION = ['DA_FareBrandDefinition'];
  var COLUMN_CUSTOMIZATION_ENABLED_TYPES = ['FP_MarketConfig'];
  var dataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.SYSTEM_STATUS_SCREEN, dataRetrieverConstantsService.SYSTEM_STATUS_CONFIGURATION_PARAMETERS_ADVANCED_MODE);
  $scope.showGrid = true;
  $scope.configurationModalData = {};
  $scope.customRenderers = _.assign({}, cellLinkRendererFactory);
  function refreshGridSettingsDynamically() {
    $scope.showGrid = true;
  }
  function changeGridSettings(type, level) {
    $scope.showGrid = false;
    $scope.readOnly = advancedGridService.isReadOnly(type, level, $scope.configType);
    $scope.settings = advancedGridService.getSettings(type, level, $scope.configType);
    var isShowSelectionCheckboxes = advancedGridService.isShowSelectionCheckboxes(type, level, $scope.configType);
    $scope.showSelectionCheckboxes = _.isUndefined(isShowSelectionCheckboxes) ? !$scope.readOnly : isShowSelectionCheckboxes;
    $scope.columnCustomizationEnabled = COLUMN_CUSTOMIZATION_ENABLED_TYPES.indexOf(type) !== -1;
    $scope.dynamicGridSuffix = $scope.columnCustomizationEnabled ? type + '-' + level : undefined;
  }
  function loadGridSettings(type, level) {
    var isDefault = level === 'default';
    dataRetriever.setCustomSearchCriteriaRules(isDefault ? [] : advancedGridService.prepareSearchCriteria(type, level, $scope.configType));
    dataRetriever.isQueryingMoreDomains(QUERYING_MORE_DOMAINS_TYPES.indexOf(type) !== -1);
    if (PRE_POPULATE_CURTAIN_RULE_DROPDOWNS_TYPES.indexOf(type) !== -1) {
      hepService.loadCurtainRuleIds();
      hepService.loadFlightCategories();
    }
    if (PRE_POPULATE_FARE_BRAND_DROPDOWN_TYPES.indexOf(type) !== -1) {
      hepService.loadDAFareBrandDefinitions();
    }
    if (PRE_POPULATE_FOR_VALIDATION.indexOf(type) !== -1) {
      hepService.loadDAFareBrandNormalizations();
      hepService.loadDAFareBrandAssignments();
    }
    dataRetriever.selectedParams({
      isDefault: isDefault,
      type: type
    });
  }
  function hepTypesWithNoHierarchy() {
    var notHierarchyTypes = ['FlightExclusion', 'FOMarketList', 'FOFareBrandDefinitionConfig'];
    return !_.includes(notHierarchyTypes, $scope.selected.type);
  }
  function changeGridSettingsAndGetData() {
    var level = $scope.selected.hierarchy;
    var type = $scope.selected.type;
    loadGridSettings(type, level);
    changeGridSettings(type, level);
    $scope.isDefaultLevel = $scope.selected.hierarchy === 'default' && hepTypesWithNoHierarchy();
    $scope.typeLabel = configurationParametersAdvancedDataProviderService.getLabelFromType(type);
    $scope.importFromCsvEnabled = isImportFromCsvEnabled(type);
  }
  $scope.customSaveValidation = function (editedRows, gridData) {
    return advancedHepGridValidationService.validate(editedRows, gridData, $scope.selected.type, $scope.configType, $scope.selected.hierarchy);
  };
  $scope.customSave = function (editedRows, gridData) {
    var requiredGridDataRowsGrids = ['FlightExclusion', 'FOMarketList', 'FOTacticalFBCPatternConfig', 'FOFareBrandDefinitionConfig'];
    var editedGridRowsRelatedData = ['FOFareBasisCodePattern', 'FOTacticalUserOverrides', 'FORbdAssignment', 'FOUpSellBuyDownConfig', 'FOTacticalUserOverrides'];
    var rowsToSave = _.includes(requiredGridDataRowsGrids, $scope.selected.type) ? gridData : editedRows;
    if (_.includes(editedGridRowsRelatedData, $scope.selected.type)) {
      var hierarchyKeys = $scope.selected.hierarchy.split('.');
      var editedKeys = _.chain(editedRows).map(function (editedRow) {
        return getKeyFromHierarchyValues(hierarchyKeys, editedRow);
      }).uniq().value();
      rowsToSave = _.chain(gridData).filter(function (gridRow) {
        return _.includes(editedKeys, getKeyFromHierarchyValues(hierarchyKeys, gridRow));
      }).value();
    }
    return advancedHepGridActionsService.save(rowsToSave, $scope.selected.type, $scope.selected.hierarchy);
  };
  $scope.makeExportToCsv = function (data) {
    advancedHepGridActionsService.exportToCsv(data, $scope.selected.type);
  };
  function getKeyFromHierarchyValues(hierarchyKeys, row) {
    var key = '';
    hierarchyKeys.forEach(function (attribute) {
      switch (attribute) {
        case 'hostCarrier':
          key += row[attribute] ? row[attribute] : '';
          break;
        case 'cabin':
          key += row['foCabin'] ? row['foCabin'] : row[attribute];
          break;
        case 'adaptivePricingCategory':
          key += row['adaptivePricingCategory'] ? row['adaptivePricingCategory'] : row[attribute];
          break;
        default:
          key += row[attribute];
      }
    });
    return key;
  }
  function isImportFromCsvEnabled(type) {
    return type !== 'CabinCapacityRestriction' && type !== 'FlightCurtainRuleId' && type !== 'CurtainRule' && type !== 'FlightCategory';
  }
  $scope.updateLOSFields = function (rowIndex, gridId) {
    $rootScope.$broadcast('grid:setMultipleCellsValue', gridId, [{
      rowId: rowIndex,
      columnName: 'lengthOfStayFrom',
      value: 0
    }, {
      rowId: rowIndex,
      columnName: 'lengthOfStayTo',
      value: 0
    }], true);
  };
  $scope.tripDirectionOneWay = function (gridId, change) {
    return gridId === 'configuration-parameters-advanced' && change.datafield === 'tripType' && change.newvalue === 'One-Way';
  };
  $scope.$watch('settings', refreshGridSettingsDynamically);
  $scope.$watch('selected', changeGridSettingsAndGetData, true);
};
AdvancedHepGridController.$inject = ['$scope', 'AdvancedHepGridService', 'AdvancedHepGridValidationService', 'AdvancedHepGridActionsService', 'DataRetrieverService', 'CellLinkRendererFactory', 'DataRetrieverConstantsService', 'ConfigurationParametersAdvancedDataProviderService', 'FeatureToggleService', 'HepService', '$rootScope'];
module.exports = AdvancedHepGridController;